import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tipoElegido: 'Inicio',
    ciudadElegidaSlug: '',
    ciudadElegidaID: '',
    comercioElegidoSlug: '',
    comercioElegidoID: '',
    LectorQRExt: '',
    alergenosElegidos: [],
    //url_base: 'http://localhost:8080',
    //url_base: 'https://opendmb.demibarrio.eu',
    url_base: 'https://lacartaweb.com'
  },
  mutations: {

    cambiarTipo (state, payload) {
      state.tipoElegido = payload
    },

    cambiarCiudadSlug (state, payload) {
      state.ciudadElegidaSlug = payload
    },

    cambiarCiudadID (state, payload) {
      state.ciudadElegidaID = payload
    },

    cambiarComercioSlug (state, payload) {
      state.comercioElegidoSlug = payload
    },

    cambiarComercioID (state, payload) {
      state.comercioElegidoID = payload
    },
    
    cambiarLectorQRExt (state, payload) {
      state.LectorQRExt = payload
    }
    
  },
  actions: {

  }
})